
import { OrderProduct } from '../../../types/orderTypes';
import { calculateProductTotal, calculateOrderTotal } from './productCalculations';

/**
 * Find a product in the products array by ID
 */
export const findProductById = (products: OrderProduct[], productId: string): OrderProduct | undefined => {
  return products.find(p => p.id === productId);
};

/**
 * Add a product to the existing products list
 * If the product already exists, increase its quantity
 */
export const addProductToList = (products: OrderProduct[], newProduct: OrderProduct): OrderProduct[] => {
  const existingIndex = products.findIndex(p => p.id === newProduct.id);
  
  if (existingIndex >= 0) {
    // Update quantity if product already in list
    const updatedProducts = [...products];
    updatedProducts[existingIndex].quantity += newProduct.quantity;
    updatedProducts[existingIndex].total = calculateProductTotal(
      updatedProducts[existingIndex].price, 
      updatedProducts[existingIndex].quantity
    );
    return updatedProducts;
  } else {
    // Add new product to list with calculated total
    const productWithTotal = {
      ...newProduct,
      total: calculateProductTotal(newProduct.price, newProduct.quantity)
    };
    return [...products, productWithTotal];
  }
};

/**
 * Remove a product from the products list by ID
 */
export const removeProductFromList = (products: OrderProduct[], productId: string): OrderProduct[] => {
  return products.filter(product => product.id !== productId);
};
